<template>
  <div class="b-seats-types">
    <div class="b-seats-types__wrapper">
      <div
        v-for="(seat, index) in seatsTypes"
        :key="index"
        class="b-seats-types__holder">
        <svg
          v-if="seat.dynamic === true"
          class="b-seats-types__seat-img"
          viewBox="0 0 22 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          v-html="seat.icon"></svg>
        <img
          v-else
          :src="seat.icon"
          alt="seat"
          class="b-seats-types__seat-img" />
        <div class="b-seats-types__name">
          {{ getDictionaryValue(seat) }}
        </div>
      </div>
    </div>

    <div v-if="selectedSeats.length" class="b-seats-types__wrapper">
      <div class="b-seats-types__holder">
        <img
          v-if="store.hasSeatsRemainingAllocate"
          src="/assets/imgs/seats/temporary.svg"
          alt="seat"
          class="b-seats-types__seat-img" />
        <img
          v-else
          src="/assets/imgs/seats/selected.svg"
          alt="seat"
          class="b-seats-types__seat-img" />
        <div class="h5">{{ dictionary.yourSeats }}</div>
      </div>
      <div
        v-if="store.hasSeatsRemainingAllocate"
        class="b-seats-types__description">
        {{ dictionary.seatsTemporaryAllocatedDescription }}
      </div>
      <div class="b-seats-types__selected-holder">
        <div v-for="(seat, index) in selectedSeats" :key="index">
          {{ seatName(seat) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, getCurrentInstance, ref } from 'vue'
import { getAllSeatTypes } from '../../../../lib/seatsTypes'
import { useBookingStore } from '../../../store/BookingStore'

const { dictionary } = getCurrentInstance().appContext.config.globalProperties

const store = useBookingStore()
const selectedSeats = ref(store.getSelectedSeats)
const seatsTypes = computed(() =>
  getAllSeatTypes(
    props.areas,
    store.bookingProgress.selectedMovie?.notAvailableSeatIcon || null,
  ),
)

const props = defineProps({
  areas: {
    type: Map,
    default: null,
  },
})

const seatName = (seat) => {
  return `${seat.physicalName}-${seat.id}`
}

const getDictionaryValue = (seat) => {
  if (seat.dynamic) {
    return seat.name
  }
  return dictionary[`seatType${seat.name}`]
}
</script>
